var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTags(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.36363636,2.16666667 C4.50872727,2.16666667 4.64672727,2.22408333 4.74927273,2.325375 L4.74927273,2.325375 L10.7492727,8.28370833 C10.9625455,8.4955 10.9625455,8.83783333 10.7492727,9.049625 L10.7492727,9.049625 L6.93109091,12.8412917 C6.82472727,12.9469167 6.68509091,13 6.54545455,13 C6.40581818,13 6.26618182,12.9469167 6.15981818,12.8412917 L6.15981818,12.8412917 L0.159818182,6.88295833 C0.0572727273,6.781125 4.75175455e-13,6.64408333 4.75175455e-13,6.5 L4.75175455e-13,6.5 L4.75175455e-13,2.70833333 C4.75175455e-13,2.40879167 0.243818182,2.16666667 0.545454545,2.16666667 L0.545454545,2.16666667 Z M5.45454545,1.33226763e-14 C5.59963636,1.33226763e-14 5.73763636,0.056875 5.84018182,0.158708333 L11.8401818,6.11704167 L11.0689091,6.88295833 L5.22872727,1.08333333 L1.63636364,1.08333333 L1.63636364,1.33226763e-14 L5.45454545,1.33226763e-14 Z M2.72727273,3.79166667 C2.124,3.79166667 1.63636364,4.27591667 1.63636364,4.875 C1.63636364,5.473 2.124,5.95833333 2.72727273,5.95833333 C3.32945455,5.95833333 3.81818182,5.473 3.81818182,4.875 C3.81818182,4.27591667 3.32945455,3.79166667 2.72727273,3.79166667 Z",
    id: "tags"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTags);
export default __webpack_public_path__ + "static/media/tags.671e694ccf4b89551c5b96a3a7d50177.svg";
export { ForwardRef as ReactComponent };